import {
  HomePageBannerModule,
  HomePageBannerProduct,
} from '@/modules/home/api';
import { TextOnlyBanner } from './components/textOnlyBanner/TextOnlyBanner';
import { ImageOnlyBanner } from './components/imageOnlyBanner/ImageOnlyBanner';
import { ImageAndTextBanner } from './components/imageAndTextBanner/ImageAndTextBanner';
import { ImageAndTextSimpleBanner } from './components/imageAndTextSimpleBanner/ImageAndTextSimpleBanner';
import { HomePageProduct } from './components/homePageProduct/HomePageProduct';
import { ProductPageBannerLocation } from '@/modules/product/api/banners';

export function renderBanner(
  banner: HomePageBannerModule | null | undefined,
  product?: ({ index: number } & HomePageBannerProduct) | null | undefined,
  name?: string,
  bannerId?: number,
  slot?: string | null,
  imageBreakpoints: Record<number, number | number[]> = {}
) {
  if (!banner?.type) return null;

  const type = banner.type;

  switch (type) {
    case 'text-only-banner': {
      return (
        <TextOnlyBanner
          data={banner.data}
          bannerId={bannerId as number}
          name={name as string}
          slot={slot}
        />
      );
    }

    case 'image-only-banner': {
      return (
        <ImageOnlyBanner
          data={banner.data}
          imageBreakpoints={imageBreakpoints}
          bannerId={bannerId as number}
          name={name as string}
          slot={slot}
        />
      );
    }

    case 'image-and-text-banner': {
      return (
        <ImageAndTextBanner
          data={banner.data}
          imageBreakpoints={imageBreakpoints}
          bannerId={bannerId as number}
          name={name as string}
          slot={slot}
        />
      );
    }

    case 'image-and-text-simple-banner': {
      return (
        <ImageAndTextSimpleBanner
          data={banner.data}
          imageBreakpoints={imageBreakpoints}
          bannerId={bannerId as number}
          name={name as string}
          slot={slot}
        />
      );
    }

    case 'product-banner': {
      return (
        <HomePageProduct
          product={product}
          bannerId={bannerId as number}
          name={name as string}
        />
      );
    }
  }

  throw new Error(`Unknown banner type: ${type}`);
}

export function getBannerSlotName(location: ProductPageBannerLocation) {
  switch (location) {
    case 'above_footer':
      return 'Banner - pas nad stopką';
    case 'inside_grid':
      return 'Banner - pas na liście produktów';
    case 'product_grid_pos_15':
      return 'Banner - kafelek na liście produktów (P15)';
    case 'product_grid_pos_39':
      return 'Banner - kafelek na liście produktów (P39)';
  }
}
